export const SUBHEADER_ID = 'subheader';

export enum SubheaderType {
  Feed = 'feed',
  MyContent = 'my-content',
  Dashboards = 'dashboards',
}
